import Vue from 'vue'
import App from './App.vue'
import router from './utils/permission'
import store from './store'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/common.scss'
import api from '@/api'
import utils from '@/utils/index'
import AuthButton from '@/components/AuthButton.vue'
import AuthSwitch from '@/components/AuthSwitch.vue'
import env from '@/api/env'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
import pageSelect from 'page-select'
import MeWangEditor from "@/components/me-wang-editor"
import md5 from 'js-md5';


Vue.config.productionTip = false

import {
	Avatar,
	Pagination,
	Dialog,
	Autocomplete,
	Dropdown,
	DropdownMenu,
	DropdownItem,
	Menu,
	Submenu,
	MenuItem,
	MenuItemGroup,
	Input,
	InputNumber,
	Radio,
	RadioGroup,
	RadioButton,
	Checkbox,
	CheckboxButton,
	CheckboxGroup,
	Switch,
	Select,
	Option,
	OptionGroup,
	Button,
	ButtonGroup,
	Table,
	TableColumn,
	DatePicker,
	TimeSelect,
	TimePicker,
	Popover,
	Tooltip,
	Breadcrumb,
	BreadcrumbItem,
	Form,
	FormItem,
	Tabs,
	TabPane,
	Tag,
	Tree,
	Alert,
	Slider,
	Icon,
	Row,
	Col,
	Upload,
	Progress,
	Spinner,
	Badge,
	Card,
	Rate,
	Steps,
	Step,
	Carousel,
	CarouselItem,
	Collapse,
	CollapseItem,
	Cascader,
	ColorPicker,
	Transfer,
	Container,
	Header,
	Aside,
	Main,
	Footer,
	Timeline,
	TimelineItem,
	Link,
	Divider,
	Image,
	Calendar,
	Backtop,
	PageHeader,
	CascaderPanel,
	Loading,
	MessageBox,
	Message,
	Notification,
	InfiniteScroll,
} from 'element-ui';

import VueAMap from 'vue-amap';

Vue.use(Avatar)
Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(Autocomplete);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Switch);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Button);
Vue.use(ButtonGroup);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(DatePicker);
Vue.use(TimeSelect);
Vue.use(TimePicker);
Vue.use(Popover);
Vue.use(Tooltip);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Tag);
Vue.use(Tree);
Vue.use(Alert);
Vue.use(Slider);
Vue.use(Icon);
Vue.use(Row);
Vue.use(Col);
Vue.use(Upload);
Vue.use(Progress);
Vue.use(Spinner);
Vue.use(Badge);
Vue.use(Card);
Vue.use(Rate);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Cascader);
Vue.use(ColorPicker);
Vue.use(Transfer);
Vue.use(Container);
Vue.use(Header);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Footer);
Vue.use(Timeline);
Vue.use(TimelineItem);
Vue.use(Link);
Vue.use(Divider);
Vue.use(Image);
Vue.use(Calendar);
Vue.use(Backtop);
Vue.use(PageHeader);
Vue.use(CascaderPanel);
Vue.use(Loading.directive);
Vue.use(VueQuillEditor);
Vue.use(VueAMap);
Vue.use(InfiniteScroll);
Vue.use(pageSelect);
Vue.use(MeWangEditor);

Vue.component('AuthButton', AuthButton);
Vue.component('AuthSwitch', AuthSwitch);
Vue.use(VideoPlayer);
Vue.component('page-select', pageSelect)

VueAMap.initAMapApiLoader({
	// 高德的key
	key: '7c40e4b50c22162c7490d5f464e3b0d4',
	// 插件集合
	plugin: [
		'AMap.Geocoder',
		'AMap.DistrictSearch',
		'AMap.MarkerClusterer',
		'AMap.DistrictLayer',
		'AMap.InfoWindow',
		'AMap.ToolBar'
	],
	// 高德 sdk 版本，默认为 1.4.4
	v: '1.4.4'
});

Vue.prototype.$api = api; // 挂载全局接口
Vue.prototype.$utils = utils;
Vue.prototype.$imgUrl = env.PROD_IMG_ENV;
Vue.prototype.$imgCommonUrl = env.IMG_COMMON_URL_PREFIX;
Vue.prototype.$host = env.PROD_ENV;
Vue.prototype.$front_host = env.PROD_FRONT_ENV;
Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;
Vue.prototype.$md5 = md5;



new Vue({
	router,
	store,
	render: h => h(App),
	filters: {
		unescape: function(html) {
			return html
				.replace(html ? /&(?!#?\w+;)/g : /&/g, '&amp;')
				.replace(/&lt;/g, "<")
				.replace(/&gt;/g, ">")
				.replace(/&quot;/g, "\"")
				.replace(/&#39;/g, "\'");
		},
	}
}).$mount('#app')


// 监听页面关闭，关闭websocket
window.addEventListener("beforeunload", e => {
	store.dispatch('websocket/close')
})
